import CashSearch from '@views/CashAudit/SearchCriteria';
import Client from '@views/Clients/ClientEdit';
import LogsView from '@views/Clients/LogsView';
import Dashboard from '@views/Dashboard/TenantDashboard';
import Device from '@views/Devices/Device';
import DeviceSearch from '@views/Devices/SearchCriteria';
import Location from '@views/Locations/Location';
import Locations from '@views/Locations/Locations';
import ParameterLists from '@views/Parameters/ParameterLists';
import ParameterSet from '@views/Parameters/ParameterSet';
import ProvisionClient from '@views/ProvisionClient/ProvisionClient';
import ReferenceLists from '@views/ReferenceLists/ReferenceLists';
import Role from '@views/Roles/Role';
import Roles from '@views/Roles/Roles';
import TemplateEditor from '@views/Templates/TemplateEditor';
import TemplateSet from '@views/Templates/TemplateSet';
import TemplateSets from '@views/Templates/TemplateSets';
import Tenant from '@views/Tenant/Tenant';
import TransactionSearch from '@views/Transactions/SearchCriteria';
import Users from '@views/Users/ClientUsers';
import User from '@views/Users/User';

// @mui/icons-material
import CashSearchIcon from '@mui/icons-material/AccountBalance';
import ReferenceIcon from '@mui/icons-material/Announcement';
import BusinessIcon from '@mui/icons-material/Business';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ParametersIcon from '@mui/icons-material/FormatListBulleted';
import RoleIcon from '@mui/icons-material/LockOpen';
import AdministratorIcon from '@mui/icons-material/People';
import PrinterIcon from '@mui/icons-material/Print';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SearchIcon from '@mui/icons-material/Search';
import EnvironmentIcon from '@mui/icons-material/SettingsInputComponent';
import LocationIcon from '@mui/icons-material/Store';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import HistoryIcon from '@mui/icons-material/History';
import ParameterHistory from 'views/ParameterHistory/ParameterHistory';

var clientRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: DashboardIcon,
    component: Dashboard,
    layout: '/admin',
  },
  {
    path: '/company',
    name: 'Company',
    icon: BusinessIcon,
    component: Client,
    layout: '/admin',
  },
  {
    path: '/provisionclient',
    name: 'Provision Company',
    component: ProvisionClient,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/environment',
    name: 'Environment',
    icon: EnvironmentIcon,
    component: Tenant,
    layout: '/admin',
  },
  {
    path: '/users',
    name: 'Admin Users',
    icon: AdministratorIcon,
    component: Users,
    layout: '/admin',
  },
  {
    path: '/locations',
    name: 'Locations',
    mini: 'PP',
    icon: LocationIcon,
    component: Locations,
    layout: '/admin',
  },
  {
    path: '/location',
    name: 'Edit Location',
    component: Location,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/devices',
    name: 'Devices',
    icon: PrinterIcon,
    component: DeviceSearch,
    layout: '/admin',
  },
  {
    path: '/device',
    name: 'Device',
    component: Device,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/parameterlists',
    name: 'Parameters',
    icon: ParametersIcon,
    component: ParameterLists,
    layout: '/admin',
  },
  {
    path: '/parameterset',
    name: 'Edit Parameter Set',
    component: ParameterSet,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/templatesets',
    name: 'Receipt Templates',
    icon: ReceiptIcon,
    component: TemplateSets,
    layout: '/admin',
  },
  {
    path: '/parameterhistory',
    name: 'Parameter History',
    icon: HistoryIcon,
    component: ParameterHistory,
    layout: '/admin',
  },
  {
    path: '/templateset',
    name: 'Edit Template Set',
    component: TemplateSet,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/templateeditor',
    name: 'Edit Template',
    component: TemplateEditor,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/referencelists',
    name: 'Reference Lists',
    icon: ReferenceIcon,
    component: ReferenceLists,
    layout: '/admin',
  },
  {
    path: '/roles',
    name: 'Store Roles',
    icon: RoleIcon,
    component: Roles,
    layout: '/admin',
  },
  {
    path: '/role',
    name: 'Edit Role',
    component: Role,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/user',
    name: 'Edit User',
    component: User,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/transactions',
    name: 'Transactions',
    icon: SearchIcon,
    component: TransactionSearch,
    layout: '/admin',
  },
  {
    path: '/cashaudit',
    name: 'Cash Count Audit',
    icon: CashSearchIcon,
    component: CashSearch,
    layout: '/admin',
  },
  {
    path: '/logs',
    name: 'Logs',
    icon: WysiwygIcon,
    component: LogsView,
    layout: '/admin',
    invisible: true,
  },
];
export default clientRoutes;
